export const TITLE = 'Import File'

export const LABELS = {
    import_excel : "Import Data Using Excel Sheet(Format- xls,xlsx).",
    upload_file : "Upload File",
    download_template : "Download Excel Template from",
    here : "Here"
}

export const BUTTONS = {
    cancel : "Cancel",
    upload : "Upload"
}